import React from 'react';
import { NavLink } from 'react-router-dom';
import ArrowDown from './icons/ArrowDown';
import List from './List';
export default class extends React.Component {

  static defaultProps = {
    showChildren: false,
    text: 'No Text',
    className: '',
    items: [],
    showToggleIcon: true,
  }

  state = {
    showChildren: this.props.showChildren,
  }

  toggleChildren = () => this.setState({ showChildren: !this.state.showChildren })
  handleClickListItem = () => {
    if (this.props.items.length > 0) {
      this.toggleChildren();
    }
  }
  render() {
    const { text, to, renderText, className, items, showToggleIcon, onClick } = this.props;
    const { showChildren } = this.state;
    
    const LinkComponent = typeof to !== `undefined` ? NavLink : 'a';
    // const LinkComponent = 'a';
    const componentProps = typeof to !== `undefined` ? { to } : { href: to, onClick };
    // if (to === `undefined`) componentProps.onClick = onClick;

    return (
      <div>
        <div className={`list-item ${className} ${showChildren ? 'open' : ''}`} onClick={this.handleClickListItem}>
          <LinkComponent {...componentProps}>
            {typeof renderText === 'function' ? renderText() : text}
          </LinkComponent>
          {items.length > 0 && showToggleIcon && (
            <button className="btn-toggle" onClick={this.toggleChildren}>
              <ArrowDown width="0.8em" height="0.8em" fill="#000" />
            </button>
          )}
        </div>
        {items.length > 0 && showChildren && (
          <List>
            {items}
          </List>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ListItem.js